<template>
  <div class></div>
</template>
<script>
export default {
  props: {},
  data() {
    return {};
  },
  watch: {},
  components: {},
  async mounted() {},
  methods: {},
  async created() {
    // 验证登录状态
    await this.$common.http({
      url: "/api/pcenter/detail"
    });
    // 下载
    this.$common.httpLoadFile({
      url: "/api/queue/summary/export"
    });
  }
};
</script>
<style lang="less" scoped></style>
